import {
    Link,
    ListItemText,
    MenuItem,
    MenuList,
    Paper,
    Typography,
} from "@mui/material";
import * as React from "react";
import { getSessionCookie } from "../../components/cookies";
import * as Service from "../../services/manual";
import { commonState } from "../../store";
import { colors } from "../../theme";
import { tsToFormattedDate } from "../../utils/humanize";
import { State } from "./store";

export interface Props {
    state: State;
    common: commonState;
}

export const ManualContainer: React.FC<Props> = (props: Props) => {
    React.useEffect(() => {
        if (!getSessionCookie().consoleUserId) return;
        Service.getManuals();
    }, [getSessionCookie().consoleUserId]);

    const manuals = props.state.manuals;

    return (
        <>
            {manuals?.length == 0 ? (
                <Paper
                    variant="outlined"
                    sx={{ p: 10, mb: 10, textAlign: "center" }}
                >
                    参照可能なマニュアルはありません
                </Paper>
            ) : (
                <Paper sx={{ mb: 10, width: "100%" }}>
                    <MenuList>
                        {/* <MenuItem
                            key={-1}
                            component={Link}
                            href={
                                "https://www.youtube.com/watch?v=Lk4RnCyEJVU&list=PLDjHOZnqrby6gZI_VV8OmHl1fOOtiN9KW"
                            }
                            target="_href"
                        >
                            <ListItemText>
                                お客様探索ナビ 動画マニュアル
                            </ListItemText>
                        </MenuItem> */}
                        {manuals?.map((manual, i) => (
                            <MenuItem
                                key={i}
                                component={Link}
                                href={`/v1/manuals/${manual.id}.pdf`}
                                target="_blank"
                            >
                                <ListItemText>{manual.name}</ListItemText>
                                <Typography
                                    variant="body2"
                                    sx={{ color: colors.black.a90 }}
                                >
                                    {tsToFormattedDate(manual.publishedAt)}
                                </Typography>
                            </MenuItem>
                        ))}
                    </MenuList>
                </Paper>
            )}
        </>
    );
};
